<template>
  <div>
    <!-- Page Banner -->
    <section class="page-banner bgs-cover overlay pt-50 ban-h mob-ban" style="background-image: url(/assets/images/banner-ai.jpg)">
      <div class="container">
        <div class="banner-inner">
          <h1 class="page-title2 clr-000">{{ $t('services.ai.subtitle') }} <br><span>{{ $t('services.ai.subtitleSpan') }}</span></h1>
        </div>
      </div>
    </section>

    <!-- Services Description -->
    <section>
      <div class="container ser-des">
        <h1 class="mt-80">{{ $t('services.ai.title') }}</h1>
        <p class="lh2 mob-ban-title mt-30 mb-80">
          {{ $t('services.ai.description') }}
        </p>
      </div>
    </section>

    <!-- Key Features Section -->
    <section class="about-section-six py-70 rpb-100 bg-bg1">
      <div class="container">
        <div class="row">
          <div class="col-md-4 aiauto1 disp-desk">
            <div class="mb-35">
              <h2 class="col-section3">{{ $t('services.ai.keyFeatures.title') }}</h2>
            </div>
          </div>
          <div class="col-md-4 disp-mob">
            <div class="mb-35">
              <h2 class="col-section3">{{ $t('services.ai.keyFeatures.title') }}</h2>
            </div>
          </div>
          <div class="col-md-8">
            <div class="about-six-content mr-0 rmr-0 wow fadeInLeft delay-0-2s pl-50">
              <div class="service-item-six">
                <div class="service-content df-it">
                  <h5>{{ $t('services.ai.keyFeatures.items.aiDrivenDecision.title') }}</h5>
                  <div class="bar"></div>
                  <p>{{ $t('services.ai.keyFeatures.items.aiDrivenDecision.description') }}</p>
                </div>
              </div>
              <div class="service-item-six">
                <div class="service-content df-it">
                  <h5>{{ $t('services.ai.keyFeatures.items.conversationalInterfaces.title') }}</h5>
                  <div class="bar"></div>
                  <p>{{ $t('services.ai.keyFeatures.items.conversationalInterfaces.description') }}</p>
                </div>
              </div>
              <div class="service-item-six">
                <div class="service-content df-it">
                  <h5>{{ $t('services.ai.keyFeatures.items.endToEndAutomation.title') }}</h5>
                  <div class="bar"></div>
                  <p>{{ $t('services.ai.keyFeatures.items.endToEndAutomation.description') }}</p>
                </div>
              </div>
              <div class="service-item-six">
                <div class="service-content df-it">
                  <h5>{{ $t('services.ai.keyFeatures.items.systemIntegrations.title') }}</h5>
                  <div class="bar"></div>
                  <p>{{ $t('services.ai.keyFeatures.items.systemIntegrations.description') }}</p>
                </div>
              </div>
              <div class="service-item-six">
                <div class="service-content df-it">
                  <h5>{{ $t('services.ai.keyFeatures.items.realTimeAnalytics.title') }}</h5>
                  <div class="bar"></div>
                  <p>{{ $t('services.ai.keyFeatures.items.realTimeAnalytics.description') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Benefits Section (Desktop) -->
    <section class="featured-section bgs-cover pt-60 rpt-95 pb-60 rpb-100 bg-bg2 disp-desk" id="BankingExpertise">
      <div class="container">
        <div class="d-flex justify-content-between">
          <div class="col-md-7 d-flex">
            <div class="col-md-6 mt-50">
              <div class="feature-item wow fadeInUp delay-0-2s exp-b exp-b1 col-xl-12 col-md-12">
                <ul class="feature-icon ta-c">
                  <li>
                    <img src="/assets/images/icon/ai-approach.png" />
                    <h5>{{ $t('services.ai.benefits.items.humanAiApproach.title') }}</h5>
                    <p class="bank-exp">{{ $t('services.ai.benefits.items.humanAiApproach.description') }}</p>
                  </li>
                </ul>
              </div>
              <div class="feature-item wow fadeInUp delay-0-2s exp-b exp-b1 col-xl-12 col-md-12">
                <ul class="feature-icon ta-c">
                  <li>
                    <img src="/assets/images/icon/seamless.png" />
                    <h5>{{ $t('services.ai.benefits.items.fasterTimeToValue.title') }}</h5>
                    <p class="bank-exp">{{ $t('services.ai.benefits.items.fasterTimeToValue.description') }}</p>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-6">
              <div class="feature-item wow fadeInUp delay-0-2s exp-b exp-b1 col-xl-12 col-md-12">
                <ul class="feature-icon ta-c">
                  <li>
                    <img src="/assets/images/icon/risk.png" />
                    <h5>{{ $t('services.ai.benefits.items.customTailoredSolutions.title') }}</h5>
                    <p class="bank-exp">{{ $t('services.ai.benefits.items.customTailoredSolutions.description') }}</p>
                  </li>
                </ul>
              </div>
              <div class="feature-item wow fadeInUp delay-0-2s exp-b exp-b1 col-xl-12 col-md-12">
                <ul class="feature-icon ta-c">
                  <li>
                    <img src="/assets/images/icon/ai-security.png" />
                    <h5>{{ $t('services.ai.benefits.items.enterpriseGradeSecurity.title') }}</h5>
                    <p class="bank-exp">{{ $t('services.ai.benefits.items.enterpriseGradeSecurity.description') }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-5 section-title1 pt-80 mb-35 pl-100">
            <h2>{{ $t('services.ai.benefits.title') }}</h2>
            <p>{{ $t('services.ai.benefits.description') }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Benefits Section (Mobile) -->
    <section class="featured-section bgs-cover pt-60 rpt-95 pb-60 rpb-100 bg-bg2 disp-mob" id="BankingExpertise">
      <div class="container">
        <div class="col-md-5 section-title1 mb-20">
          <h2>{{ $t('services.ai.benefits.title') }}</h2>
          <p>{{ $t('services.ai.benefits.description') }}</p>
        </div>
        <div class="d-flex justify-content-between">
          <div class="col-md-7">
            <div class="col-md-6 mt-50">
              <div class="feature-item wow fadeInUp delay-0-2s exp-b exp-b1 col-xl-12 col-md-12">
                <ul class="feature-icon ta-c">
                  <li>
                    <img src="/assets/images/icon/ai-approach.png" />
                    <h5>{{ $t('services.ai.benefits.items.humanAiApproach.title') }}</h5>
                    <p class="bank-exp">{{ $t('services.ai.benefits.items.humanAiApproach.description') }}</p>
                  </li>
                </ul>
              </div>
              <div class="feature-item wow fadeInUp delay-0-2s exp-b exp-b1 col-xl-12 col-md-12">
                <ul class="feature-icon ta-c">
                  <li>
                    <img src="/assets/images/icon/seamless.png" />
                    <h5>{{ $t('services.ai.benefits.items.fasterTimeToValue.title') }}</h5>
                    <p class="bank-exp">{{ $t('services.ai.benefits.items.fasterTimeToValue.description') }}</p>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-6">
              <div class="feature-item wow fadeInUp delay-0-2s exp-b exp-b1 col-xl-12 col-md-12">
                <ul class="feature-icon ta-c">
                  <li>
                    <img src="/assets/images/icon/risk.png" />
                    <h5>{{ $t('services.ai.benefits.items.customTailoredSolutions.title') }}</h5>
                    <p class="bank-exp">{{ $t('services.ai.benefits.items.customTailoredSolutions.description') }}</p>
                  </li>
                </ul>
              </div>
              <div class="feature-item wow fadeInUp delay-0-2s exp-b exp-b1 col-xl-12 col-md-12">
                <ul class="feature-icon ta-c">
                  <li>
                    <img src="/assets/images/icon/ai-security.png" />
                    <h5>{{ $t('services.ai.benefits.items.enterpriseGradeSecurity.title') }}</h5>
                    <p class="bank-exp">{{ $t('services.ai.benefits.items.enterpriseGradeSecurity.description') }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Call to Action -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 bg-bg1 back-end" id="BackendDevelopment" style="background-image: url(/assets/images/lets_build.jpg)">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 mt-40">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w dclr-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="lets">
                    <h2>{{ $t('services.ai.callToAction.title') }}</h2>
                    <button>{{ $t('services.ai.callToAction.button') }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <!-- Empty column for spacing -->
          </div>
        </div>
      </div>
    </section>

    <!-- Services Offered Title -->
    <div>
      <h1 class="hiw mt-50">{{ $t('services.ai.servicesOffered.title') }}</h1>
    </div>

    <!-- Chatbots & Agents Section -->
    <section class="about-section-eight pt-60 rpt-35 pb-60 rpb-100" id="chatbots">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="about-eight-images aei rmb-55 wow fadeInLeft delay-0-2s">
              <img src="/assets/images/services/chatbot.png" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title2">
                    <h2>{{ $t('services.ai.servicesOffered.chatbots.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <p>{{ $t('services.ai.servicesOffered.chatbots.description') }}</p>
                <li v-for="(feature, index) in $tm('services.ai.servicesOffered.chatbots.features')" :key="index">
                  <p>{{ feature }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- HR Automation Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 bg-bg1" id="hrautomation">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 order1">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title2">
                    <h2>{{ $t('services.ai.servicesOffered.hrAutomation.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <p>{{ $t('services.ai.servicesOffered.hrAutomation.description') }}</p>
                <li v-for="(feature, index) in $tm('services.ai.servicesOffered.hrAutomation.features')" :key="index">
                  <p>{{ feature }}</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 order">
            <div class="about-eight-images aei rmb-55 wow fadeInLeft delay-0-2s">
              <img class="mar-l" src="/assets/images/services/hr.png" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- OCR & Document Processing Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100" id="ocr">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="about-eight-images aei rmb-55 wow fadeInLeft delay-0-2s">
              <img src="/assets/images/services/ocr.png" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title2">
                    <h2>{{ $t('services.ai.servicesOffered.ocr.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <p>{{ $t('services.ai.servicesOffered.ocr.description') }}</p>
                <li v-for="(feature, index) in $tm('services.ai.servicesOffered.ocr.features')" :key="index">
                  <p>{{ feature }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Workflow Orchestration Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 bg-bg1" id="workfloworchestration">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 order1">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title2">
                    <h2>{{ $t('services.ai.servicesOffered.workflowOrchestration.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three mt-15">
                <p>{{ $t('services.ai.servicesOffered.workflowOrchestration.description') }}</p>
                <li v-for="(feature, index) in $tm('services.ai.servicesOffered.workflowOrchestration.features')" :key="index">
                  <p>{{ feature }}</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 order">
            <div class="about-eight-images aei rmb-55 wow fadeInLeft delay-0-2s">
              <img class="mar-l" src="/assets/images/services/workflow-o.png" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- IT Support Assistant Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100" id="itsupport">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="about-eight-images aei rmb-55 wow fadeInLeft delay-0-2s">
              <img src="/assets/images/services/itassistant.png" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title2">
                    <h2>{{ $t('services.ai.servicesOffered.itSupport.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <p>{{ $t('services.ai.servicesOffered.itSupport.description') }}</p>
                <li v-for="(feature, index) in $tm('services.ai.servicesOffered.itSupport.features')" :key="index">
                  <p>{{ feature }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Intelligent Process Automation Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 bg-bg1" id="intelligentprocess">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 order1">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title2">
                    <h2>{{ $t('services.ai.servicesOffered.intelligentProcess.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <p>{{ $t('services.ai.servicesOffered.intelligentProcess.description') }}</p>
                <li v-for="(feature, index) in $tm('services.ai.servicesOffered.intelligentProcess.features')" :key="index">
                  <p>{{ feature }}</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 order">
            <div class="about-eight-images aei rmb-55 wow fadeInLeft delay-0-2s">
              <img class="mar-l" src="/assets/images/services/automation-o.png" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- IT Production Support Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100" id="itproductionsupport">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="about-eight-images aei rmb-55 wow fadeInLeft delay-0-2s">
              <img src="/assets/images/services/prod.png" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title2">
                    <h2>{{ $t('services.ai.servicesOffered.itProductionSupport.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <p>{{ $t('services.ai.servicesOffered.itProductionSupport.description') }}</p>
                <li v-for="(feature, index) in $tm('services.ai.servicesOffered.itProductionSupport.features')" :key="index">
                  <p>{{ feature }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Internal Knowledge Base Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 bg-bg1" id="internalknowledge">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 order1">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title2">
                    <h2>{{ $t('services.ai.servicesOffered.internalKnowledge.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <p>{{ $t('services.ai.servicesOffered.internalKnowledge.description') }}</p>
                <li v-for="(feature, index) in $tm('services.ai.servicesOffered.internalKnowledge.features')" :key="index">
                  <p>{{ feature }}</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 order">
            <div class="about-eight-images aei rmb-55 wow fadeInLeft delay-0-2s">
              <img class="mar-l" src="/assets/images/services/knowledgebased-o.png" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ServicesAI'
}
</script>
